import Container from '@components/ui/layout/Container';
import { Heading, Text } from '@components/ui/typography';
import { spacingBottomM } from '@components/_blog-detail/spacings';
import { parse } from '@config/theme';
import { decodeAssetId } from '@lib/sanity/decode-asset-id';
import { blurImage, urlFor } from '@lib/sanity/url-for';
import { cx } from '@linaria/core';
import Image from 'next/image';
import React, { FC } from 'react';
import { CbImageWithText as CbImageWithTextModel } from '__generated__/sanity';
export const CbImageWithText: FC<CbImageWithTextModel> = ({
  image,
  title,
  text,
  alignment
}) => {
  const {
    dimensions
  } = decodeAssetId(image.asset._ref);

  // Make sure the width is max 600
  const decreasePercentage = (100 - Math.round(100 - 600 * 100 / dimensions.width)) / 100;
  const width = dimensions.width * decreasePercentage;
  const height = dimensions.height * decreasePercentage;
  return <Container className={cx(grid, spacingBottomM)} data-alignment={alignment}>
      <div data-image="">
        <Image layout="responsive" width={width} height={height} src={urlFor(image).width(600).toString()} alt={image.alt} blurDataURL={blurImage(image)} placeholder="blur" />
      </div>
      <div data-content="" className={parse({
      mt: {
        _: '8',
        sm: '0'
      }
    })}>
        {title && <Heading as="h2" variant="h4" mb="4">
            {title}
          </Heading>}
        <Text variant="bodyRegular">{text}</Text>
      </div>
    </Container>;
};
const grid = parse({
  display: 'grid',
  alignItems: 'center'
}, "g1qnak05");

require("./CbImageWithText.linaria.module.css!=!../../../node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js?cacheProvider=!./CbImageWithText.tsx");